// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2gYJv","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2Mdvh"};